import React, { useEffect, useState, useContext } from 'react'
import './gameContent.scss'

import { Context } from '../../../context/app-context'


import { gameId } from '../../../constants/activity-constants'
import GameServices from '../../../services/game-service'
import userSessionStorage from '../../../utils/userSessionStorage'

import girnaldas from '../../../assets/images/game/girnaldas.png'
import medias from '../../../assets/images/game/medias.png'

import decoration1 from '../../../assets/images/game/decoration-1.png'
import decoration2 from '../../../assets/images/game/decoration-2.png'
import decoration3 from '../../../assets/images/game/decoration-3.png'

import santa1 from '../../../assets/images/game/santa-1.svg'
import santa2 from '../../../assets/images/game/santa-2.svg'
import santa3 from '../../../assets/images/game/santa-3.svg'

import santaPortrait from '../../../assets/images/game/portrait.png'


import red from '../../../assets/sounds/red.mp3'
import blue from '../../../assets/sounds/blue.mp3'
import green from '../../../assets/sounds/green.mp3'
import yellow from '../../../assets/sounds/yellow.mp3'

import useWindowSize from '../../../utils/useWindowsSize'
import { navigate } from 'gatsby'

const GameContent = () => {
  const sizeWidnows = useWindowSize()
  const { dispatch } = useContext(Context)
  const [session] = useState(new userSessionStorage())

  const [actualScene, setActualScene] = useState(false)
  const [isPortrait, setIsPortrait] = useState(true)

  // game vaiables
  const [round, setRound] = useState(0)
  const [userPosition, setUserPosition] = useState(0)
  const [totalRounds, setTotalRounds] = useState(10)
  const [sequence, setSequence] = useState(false)
  const [speed, setSpeed] = useState(450)
  const [blockButtons, setBlockButtons] = useState(true)

  const [points, setPoints] = useState(0)

  // array button
  const [buttons, setButtons] = useState([])

  const [startButton, setStartButton] = useState(false)


  const buttonsSound = [
    typeof Audio !== 'undefined' && new Audio(red),
    typeof Audio !== 'undefined' && new Audio(blue),
    typeof Audio !== 'undefined' && new Audio(green),
    typeof Audio !== 'undefined' && new Audio(yellow),
  ]

  const handleTokenGameRedemption = async (points) => {
    let tokenParticipationSession = sessionStorage.getItem('tokenParticipation')


    let payload = {
      point: points,
      tokenGame: tokenParticipationSession,
      gameId: gameId,
    }

    let tokenId = session.getToken().idToken

    let config = {
      headers: {
        Authorization: tokenId,
      },
    }
    try {
      const participationSaveResponse = await GameServices.postGameParticipationSave(
        payload,
        config,
      )
    } catch (error) {
      console.log(error)
    }
  }


  const handleSuccessModal = () => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: null,
      },
    })
    // startGame()

  }
  useEffect(() => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: `login`,
          props: {
            close: () => {
              navigate('/')
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
            handleStartGame: () => {
              handleSuccessModal()
            },
          },
        },
      },
    })

  }, [])


  useEffect(() => {
    // load scene
    let scene = Math.floor((Math.random() * (3 - 1 + 1)) + 1)
    setActualScene(scene)

    // load sequenze
    let arraySequence = createSequence()

    setSequence(arraySequence)

    // load buttons

    let buttonsUI = document.getElementsByClassName('f-section-game__button')
    setButtons(buttonsUI)
  }, [])

  useEffect(() => {
    if (window.matchMedia('(orientation: portrait)').matches) {
      // you're in PORTRAIT mode
      setIsPortrait(true)
    } else {
      setIsPortrait(false)

    }
  }, [sizeWidnows])


  const sceneInfo = [
    {
      santa: santa2,
      decoration: decoration1,
    },
    {
      santa: santa2,
      decoration: decoration2,
    },
    {
      santa: santa3,
      decoration: decoration3,
    },
  ]


  const startGame = () => {
    setStartButton(true)
    setRound(0)
    setUserPosition(0)
    showSequence(0)

  }

  // Crea el array aleatorio de botones
  const createSequence = () => {
    return Array.from({ length: totalRounds }, () => getRandomColor())
  }
  const getRandomColor = () => {
    return Math.floor(Math.random() * 4)
  }


  const buttonClick = (value) => {
    !blockButtons && validateChosenColor(value)
  }

  const validateChosenColor = (value) => {
    if (sequence[userPosition] === value) {
      buttonsSound[value].currentTime = 0
      buttonsSound[value].play()
      const button = buttons[value]
      toggleButtonStyle(button)
      setTimeout(() => toggleButtonStyle(button), speed / 2)

      if (round === userPosition) {
        setRound(round + 1)
        setSpeed(speed / 1.02)
        isGameOver(round + 1)
      } else {
        setUserPosition(userPosition + 1)
      }

    } else {
      gameLost()
    }
  }

  const isGameOver = (actualRound) => {
    if (actualRound === totalRounds) {
      setPoints(100)
      gameWon()
    } else {
      setUserPosition(0)
      setTimeout(() => {
        showSequence(actualRound)
      }, 1000)
    }
  }

  const showSequence = (actualRound) => {
    setBlockButtons(true)
    let sequenceIndex = 0
    let timer = setInterval(() => {

      const button = buttons[sequence[sequenceIndex]]
      buttonsSound[sequence[sequenceIndex]].currentTime = 0
      buttonsSound[sequence[sequenceIndex]].play()

      toggleButtonStyle(button)
      setTimeout(() => toggleButtonStyle(button), speed / 2)

      sequenceIndex++
      // console.log('index secuencia ++', sequenceIndex)
      // console.log('show secuence ===================')

      if (sequenceIndex > actualRound) {
        setBlockButtons(false)
        clearInterval(timer)
      }
    }, speed)
  }


  const toggleButtonStyle = (btn) => {
    btn.classList.toggle('active')
  }

  const gameLost = () => {
    setBlockButtons(true)
    handleTokenGameRedemption(points)
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: `endFailure`,
          props: {
            close: () => {
              navigate('/')
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
            points: points,
          },
        },
      },
    })
  }

  const gameWon = () => {
    setBlockButtons(true)
    handleTokenGameRedemption(100)
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: `endSuccess`,
          props: {
            close: () => {
              navigate('/')
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
            points: 100,

          },
        },
      },
    })
  }

  useEffect(() => {
    if (round === 0) {
      setPoints(0)
    } else {
      setPoints(round * 10)
    }

  }, [round])

  return (
    <>
      {(actualScene && sequence) ? (
        <section className={`f-section-game scene-${actualScene}`}>
          {isPortrait ? (
            <div className='f-section-game__portrait'>
              <img src={santaPortrait} alt='Animacion santa' />
            </div>
          ) : (
            <div className='f-section-game__wrapper'>
              <div className='f-section-game__gift'>

                {actualScene === 1 && (
                  <img
                    src={medias}
                    alt='medias'
                    className='f-section-game__gift__medias'
                  />
                )}

                {actualScene === 2 && (
                  <img
                    src={girnaldas}
                    alt='girnaldas'
                    className='f-section-game__gift__girnaldas'
                  />
                )}


                <img
                  src={sceneInfo[actualScene - 1].decoration}
                  alt='regalos'
                  className={`f-section-game__gift__decoration-decoration-${actualScene}`}

                />
              </div>
              <div className='f-section-game__santa'>
                <img
                  src={sceneInfo[actualScene - 1].santa}
                  alt='santa'
                  className='f-section-game__gift__regalos'
                />
                <div className='f-section-game__santa__info'>
                  <div className='f-section-game__santa__info__points'>
                    <span> Tu Puntaje</span>
                    <span>{points} </span>
                  </div>
                  <div className='f-section-game__santa__info__round'>
                    <span>Ronda </span>
                    <span>{round + 1} </span>
                  </div>
                </div>
              </div>
              <div className='f-section-game__game-content'>
                <div className='f-section-game__game-content__wrapper'>

                  <button
                    className='f-section-game__button red'
                    onClick={() => buttonClick(0)}
                  />
                  <button
                    className='f-section-game__button blue'
                    onClick={() => buttonClick(1)}
                  />
                  <button
                    className='f-section-game__button green '
                    onClick={() => buttonClick(2)}
                  />
                  <button
                    className='f-section-game__button yellow'

                    onClick={() => buttonClick(3)}
                  />

                </div>
                {!startButton && (
                  <button
                    disabled={startButton}
                    onClick={() => startGame()}
                    className='f-section-game__game-content__start'
                  />
                )}


              </div>

            </div>
          )}


        </section>
      ) : (
        <>LOAD</>
      )}

    </>
  )
}

export default GameContent
